import React, { useState } from "react";
import { useForm } from "react-hook-form";
import InputSelect from "components/ui/forms/InputSelect";
import InputField from "components/ui/forms/InputField";
import Button from "components/ui/Button";
import { useTranslation } from "react-i18next";

const VerifyAccount = () => {
  const inputRef = React.createRef();
  const [fileName, setFileName] = useState("Choose File");
  const [disableBtn, showDisableBtn] = useState(false);
  const { t } = useTranslation();
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const onSubmit = async (data) => {
    // console.log(data);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    showDisableBtn(file);
    if (file) {
      setFileName(file.name);
    }
  };

  const slipData = [
    { label: "Bank Slip", value: "bankslip" },
    { label: "Document", value: "document" },
    { label: "Passport/ ID card", value: "passportcard" },
    { label: "Driver's License", value: "driverslicense" },
    { label: "IBAN", value: "iban" },
    { label: "Social Card ID", value: "socialcardid" },
    { label: "Other", value: "other" },
  ];

  return (
    <>
      <p className="sm:text-[rgb(255,255,255,.5)] text-[rgb(255,255,255,.5)] lg:text-[rgb(255,255,255,.8)] text-[12px] mb-4 lg:leading-[24px] lg:tracking-[.46px]">
        •{t("Please select Your Type of ID (Bank slip, Passport or other)")}
        <br />•{t("Choose File and click “BROWSE”")}
        <br />•
        {t(
          "Click the “VERIFY” button and your account will be verified and shown in the status tab - above “My Profile”, if your documents are “Accepted”."
        )}
        <br />
        {t("ATTENTION Only JPG, PNG, GIF, or PDF format files not exceeding 10MB are supported.")}
      </p>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="flex md:flex-row flex-col gap-2">
          <InputSelect
            label="Please select your type of ID"
            name="verifyDocument"
            defaultValue={slipData[0]}
            control={control}
            options={slipData}
            className="w-full md:min-w-[300px]"
          />
          <div className="relative w-full bg-white/15 rounded px-4 py-2 flex items-center justify-between cursor-pointer">
            <span className="flex flex-col">
              <span className="text-[rgb(255,255,255,.4)] text-[12px]">Attach file</span>
              <span className="text-[rgb(255,255,255,1)] text-[12px]">{fileName}</span>
            </span>
            <i className="text-[16px] text-[rgb(255,255,255,.8)] text-sm bc-i-upload"></i>
            <InputField
              type="file"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" // Keeps the input interactable
              control={control}
              name="uploadfile"
              ref={inputRef}
              onChange={(e) => {
                handleFileChange(e);
              }}
              // {...register("uploadfile", { required: "Please upload an image and select a type of identification method." })}
              // error={errors.uploadfile?.message}
            />
          </div>
          {/* <InputField
            className="w-full"
            type="file"
            label="Attach file"
            placeholder="Choose File"
            postfix={<i className="bc-i-upload"></i>}
            control={control}
            name="uploadfile"
            ref={inputRef}
            onChange={(e) => {
              handleFileChange(e);
            }}
          /> */}

          <Button
            label={t("Verify")}
            type="submit"
            size="small"
            variant="green"
            className="uppercase md:max-w-[100px] w-full md:ml-3 md:mt-0 mt-6 flex items-center "
            disabled={!disableBtn}
          />
        </div>
      </form>
      <div className="flex flex-col">
        <span className="text-[14px] my-2 pt-[10px] text-[rgb(255,255,255,.6)] border-t-2 border-t-[rgb(255,255,255,.3)]">
          {t("Uploaded documents")}
        </span>
        <span className="text-[10px] text-[rgb(255,255,255,.5)]">{t("There are no uploaded documents.")}</span>
      </div>
    </>
  );
};

export default VerifyAccount;
